import { useQuery } from '@tanstack/react-query';
import { queryFetch } from '@services/api';
import { queryKeys } from '@utils/consts';
import { useQueryParams } from '@hooks/queryParams';
import { UsersSchedulesProps, UsersSchedulesRespSuccess } from './types';
import { ApiError } from '@root/globalTypes';

export const useGetUsersSchedules = ({
  date,
  specialties,
  users,
  status,
  crewTypes: initialCrewTypes,
  active = true,
  divisionIds: initialDivisionIds,
  search,
  onlyForRoutes,
  scheduleId,
}: UsersSchedulesProps) => {
  const {
    params: { routeId, divisionIds, allUsers, workflowIds, crewTypes, team, ...params },
    parseParams,
  } = useQueryParams();

  const queryParams = parseParams(
    {
      search: typeof search === 'string' ? search : params.search,
      date,
      status: status || params.status || '',
      crewTypes: initialCrewTypes ? [initialCrewTypes].flat() : crewTypes ? [crewTypes].flat() : [],
      foremanSpecialty: allUsers ? [] : specialties || team || [],
      userIds: users || [],
      routeId: onlyForRoutes ? routeId : '',
      divisionIds: allUsers ? [] : initialDivisionIds || divisionIds,
      onlyForRoutes,
      workflowIds,
      scheduleId: scheduleId !== 'new' ? scheduleId : '',
    },
    { arrayFormat: 'bracket' },
  );

  const { data, error, isPending, isFetching } = useQuery<UsersSchedulesRespSuccess, ApiError>({
    queryKey: [...queryKeys.schedules.internal.index, queryParams],
    queryFn: () =>
      queryFetch({
        url: `users_schedules${queryParams}`,
      }),
    placeholderData: (previousData) => previousData as UsersSchedulesRespSuccess,
    enabled: active,
  });

  return {
    data,
    error,
    isLoading: isPending && active,
    isFetching: isFetching && active,
  };
};
